/**
 * [pug template]
 */
<template lang="pug">
  div(:class="{ 'olst-field-error': hasError, 'olst-field-warning': hasWarning, 'olst-field-info': hasInfo }")
    .olst-field-material.mobile-display
      div
        label-component.olst-field-label(:name="fieldRef", :text="field.label")
        modal(v-if="field.toolTip && field.toolTip.length", :name="fieldRef", :tooltip="field.toolTip")
        .olst-material-color-label(v-html="imageLabel")
      .olst-material-checkbox(v-if="filters && filters.length")
        .olst-field-checkbox.olst-field-multi-checkbox.olst-field-checkbox(v-for="filter in filters", :class="{ 'olst-field-unique-checkbox': !hasMultiCheckbox(), 'olst-field-checkbox-big': isBigCheckboxList(filter.key), 'olst-field-checkbox-small': !isBigCheckboxList(filter.key) }")
          checkbox-list(:name="filter.key", :filter="filter.value", :withAll="true", :hideFilters="filter.closed", v-on:value-changed="filterChanged", v-on:label-clicked="toggleFilter")
        .olst-clear
      div
        .olst-color-picker
          image-radio-list(:options="field.values", :name="fieldRef", :tooltip_options="field.range", :hiddenValues="hiddenValue", :disabledValues="disabledValue", v-on:image-label-changed="imageLabelChanged", v-on:value-changed="fieldChanged", :defaultField="field.defaultVal")
    .olst-field-validation(v-for="messages, key, index in field.validation", v-if="isValidationMessage(key)")
      div(v-for="message in messages", :class="{ 'olst-field-error': isTypeError(key), 'olst-field-warning': isTypeWarning(key), 'olst-field-infos': isTypeInfo(key) }")
        text-component(:text="__t(message)")
</template>
/**
 * [javascript application]
 */
<script>
import config from '../../config/global'
import { MaterialComputed, MaterialMethods, MaterialWatch } from '../../lib/inherited/material.js'
import { RenderingUnitComputed, RenderingUnitMethods, RenderingUnitWatch } from '../../lib/inherited/rendering_unit.js'

export default {
  name: 'material-mobile',
  props: {
    fieldRef: {
      type: String,
      default: ''
    },
    productReference: {
      type: String,
      default: null
    },
    version: {
      type: String,
      default: 'default'
    },
    field: {
      type: Object,
      default: { label: '', range: {}, options: [], filters: {} }
    },
    uom: {
      type: String,
      default: 'cm'
    },
    mint: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      overImage: null,
      imageLabel: '',
      filters: []
    }
  },
  components: config.components,
  created: function () {
    /* Tri des filtres */
    var toAppend = null

    for (var index in this.field.filters) {
      if (index.indexOf('colori') !== -1) {
        toAppend = {
          key: index,
          value: this.field.filters[index],
          closed: true
        }
      } else {
        this.filters.push({
          key: index,
          value: this.field.filters[index],
          closed: true
        })
      }
    }

    if (toAppend) {
      this.filters.push(toAppend)
    }
  },
  computed: Object.assign({}, RenderingUnitComputed, MaterialComputed),
  methods: Object.assign({}, RenderingUnitMethods, MaterialMethods, {
    toggleFilter: function (data) {
      for (var index in this.filters) {
        if (this.filters[index].key === data.name) {
          this.filters[index].closed = !this.filters[index].closed
        }
      }
    }
  }),
  watch: Object.assign({}, RenderingUnitWatch, MaterialWatch)
}
</script>
/**
 * [scss styles]
 */
<style lang="scss">
</style>



// WEBPACK FOOTER //
// MaterialMobile.vue?7efc2086